export default function (instance) {
  return {
    getSubscriptionAll () {
      return instance
        .get('/api/subscriptions')
        .then(response => response.data)
    },

    getSubscriptionDetailsById (subscriptionNumber) {
      return instance
        .get(`/api/subscriptions/${subscriptionNumber}`)
        .then(response => response.data)
    },

    payInFull (subscriptionNumber, subscriptionRatePlanId, promotionCode) {
      return instance
        .post('/api/subscriptions/payinfull', {
          subscriptionNumber,
          subscriptionRatePlanId,
          promotionCode
        })
        .then(response => response.data)
    },

    // cancel bundles replenishment
    cancelReplenishment (subscriptionNumber) {
      return instance
        .post(`/api/replenishments/${subscriptionNumber}/cancellation`)
        .then(response => response.data)
    },

    // cancel only replenishment
    cancelOnlyReplenshipmentSubscription (subscriptionNumber, cancellationReason, cancellationNote) {
      return instance
        .post(`/api/subscriptions/${subscriptionNumber}/replenishment-only/cancellation`, {
          cancellationReason,
          cancellationNote
        })
        .then(response => response.data)
    },

    // try buy return reason api
    returnTryBuySubscription (subscriptionNumber, scope, cancellationReason, cancellationNote) {
      return instance
        .post(`/api/return?subscriptionNumber=${subscriptionNumber}`, {
          scope,
          cancellationReason,
          cancellationNote
        })
        .then(response => response.data)
    },

    returnTryBuyBundledReturn (subscriptionNumber, scope, cancellationReason, cancellationNote) {
      return instance
        .post(`/api/return/TryBuyBundledReturn?subscriptionNumber=${subscriptionNumber}`, {
          scope,
          cancellationReason,
          cancellationNote
        })
        .then(response => response.data)
    },

    returnOnlyReplenishmentSubscription (subscriptionNumber, cancellationReason, cancellationNote) {
      return instance
        .post(`/api/subscriptions/${subscriptionNumber}/return`, {
          cancellationReason,
          cancellationNote
        })
        .then(response => response.data)
    },

    returningWithdraw (subscriptionNumber, scope) {
      return instance
        .post(`/api/return/returning-withdraw?subscriptionNumber=${subscriptionNumber}&scope=${scope}`)
        .then(response => response.data)
    },

    getReturnAddress (subscriptionNumber) {
      return instance
        .get(`/api/subscriptions/${subscriptionNumber}/return-address`)
        .then(response => response.data)
    },

    getReturnAddress2 () {
      return instance
        .get('/api/return/address')
        .then(response => response.data)
    },

    // re-updateReturnAddress
    updateReturnAddress2 (scope, subscriptionNumber, address) {
      return instance
        .post('/api/return/address', {
          scope,
          subscriptionNumber,
          address
        })
        .then(response => response.data)
    },

    updateReAddress (subscriptionNumber, address) {
      return instance
        .post('/api/subscriptions/return-address', {
          subscriptionNumber,
          address
        })
        .then(response => response.data)
    },

    getReturnCarries (subscriptionNumber, scope) {
      return instance
        .get('/api/return/return-carriers', {
          params: {
            subscriptionNumber,
            scope
          },
          timeout: 100000
        })
        .then(response => response.data)
    },

    submitReturnCarrier (subscriptionNumber, tryBuyCarrier, replenishmentCarrier) {
      return instance
        .post('/api/return/return-carrier', {
          subscriptionNumber,
          tryBuyCarrier,
          replenishmentCarrier
        }, {
          timeout: 100000
        })
        .then(response => response.data)
    },

    getReturnDetails (subscriptionNumber) {
      return instance
        .get(`/api/subscriptions/${subscriptionNumber}/return-detail`)
        .then(response => response.data)
    },

    postponeReplenishment (subscriptionNumber) {
      return instance
        .post(`/api/replenishments/${subscriptionNumber}/postpone`)
        .then(response => response.data)
    },

    changeBillPeriod (subscriptionNumber, newProductRatePlanId) {
      return instance
        .post(`/api/replenishments/${subscriptionNumber}/frequency-change`, {
          newProductRatePlanId
        })
        .then(response => response.data)
    },

    orderOneTimeReplenishment (subscriptionNumber, subscriptionRatePlanId) {
      return instance
        .post('/api/subscriptions/oneTimeOrder-replenishment', {
          subscriptionNumber,
          subscriptionRatePlanId
        })
        .then(response => response.data)
    },

    preview (orderNumber, promotionCode, replenishmentQuantity) {
      return instance
        .post('/api/subscriptions/preview', {
          orderNumber,
          promotionCode,
          replenishmentQuantity
        })
        .then(response => response.data)
    },

    applyPromotionCode (subscriptionNumber, promotionCode) {
      return instance
        .post('/api/subscriptions/apply-promotionCode', {
          subscriptionNumber,
          promotionCode
        })
        .then(response => response.data)
    },

    payInFullPreview (subscriptionNumber, subscriptionRatePlanId, promotionCode) {
      return instance
        .get(`/api/subscriptions/${subscriptionNumber}/try-buy/${subscriptionRatePlanId}/pay-in-full-preview`, {
          params: {
            promotionCode
          }
        })
        .then(response => response.data)
    },

    shippingNowReplenishment (subscriptionNumber, subscriptionRatePlanId) {
      return instance
        .post(`/api/subscriptions/${subscriptionNumber}/replenishment/${subscriptionRatePlanId}/shipping-now`)
        .then(response => response.data)
    },

    previewV2 (bundles) {
      return instance
        .post('/api/v2/subscriptions/preview', bundles)
        .then(response => response.data)
    },

    getReturnInfo (subscriptionNumber) {
      return instance
        .get('/api/return/info', {
          params: {
            subscriptionNumber
          }
        })
        .then(response => response.data)
    },
    
    getReturnDetailsBySubscriptionNumber (subscriptionNumber) {
      return instance
        .get('/api/return/details', {
          params: {
            subscriptionNumber
          }
        })
        .then(response => response.data)
    },

    indefinitelyPauseSubscription (subscriptionNumber) {
      return instance
        .post(`/api/replenishments/${subscriptionNumber}/pausing`)
    },

    specificDatePauseSubscription (subscriptionNumber, resumeDate) {
      return instance
        .post(`/api/replenishments/${subscriptionNumber}/pausing?resumeDate=${resumeDate}`)
    },

    resumeSubscription (subscriptionNumber) {
      return instance
        .post(`/api/replenishments/${subscriptionNumber}/resume`)
    },

    resumeSubscriptionWithResumeDate (subscriptionNumber, resumeDate) {
      return instance
        .post(`/api/replenishments/${subscriptionNumber}/resume-date?resumeDate=${resumeDate}`)
    },

    getReplenishmentsDetails (subscriptionNumber) {
      return instance
        .get(`/api/replenishments/${subscriptionNumber}`)
    },

    replenishmentCancellationPreview (subscriptionNumber) {
      return instance
        .post(`/api/replenishments/${subscriptionNumber}/cancellation-preview`)
    },

    cancellationSubscription (subscriptionNumber, cancellationReason, cancellationNote) {
      return instance.post(`/api/subscriptions/${subscriptionNumber}/cancellation`, {
        cancellationReason,
        cancellationNote
      })
    },

    bcbscancellation (subscriptionNumber, cancellationReason, cancellationNote) {
      return instance.post(`/api/subscriptions/${subscriptionNumber}/bcbscancellation`, {
        cancellationReason,
        cancellationNote
      })
    },

    repair (subscriptionNumber) {
      return instance.post(`/api/subscriptions/${subscriptionNumber}/repair`, {
        subscriptionNumber
      })
    },

    sendcancelemail (name, surName, fromEmail, subscriptionNumber) {
      return instance.post(`/api/user/SendCancelEmail`, {
        name,
        surName,
        fromEmail,
        subscriptionNumber

      })
    },

    changeReplenishmentType (subscriptionNumber, newProductRatePlanId) {
      return instance.post(`/api/replenishments/${subscriptionNumber}/change`, {
        newProductRatePlanId
      }).then(response => response.data)
    }
  }
}
